"use strict";

require("core-js/modules/es.object.define-property.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _excluded = ["children", "error", "isExclusiveAnswer"];
var AccessibleFieldset = function AccessibleFieldset(_ref) {
  var children = _ref.children,
    error = _ref.error,
    _ref$isExclusiveAnswe = _ref.isExclusiveAnswer,
    isExclusiveAnswer = _ref$isExclusiveAnswe === void 0 ? false : _ref$isExclusiveAnswe,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return isExclusiveAnswer ? /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])("evi--fieldset", error && 'evi--fieldset-error')
  }, children) : /*#__PURE__*/_react["default"].createElement("fieldset", (0, _extends2["default"])({
    className: (0, _clsx["default"])("evi--fieldset", error && 'evi--fieldset-error')
  }, rest), children);
};
var _default = exports["default"] = AccessibleFieldset;